import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home         from './pages/Home';
import About        from './pages/About';
import Process      from './pages/Process';
import Services     from './pages/Services';
import Gallery      from './pages/Gallery';
import Testimonials from './pages/Testimonials';
import Contact      from './pages/Contact';

import Login     from './portal/Login';
import Dashboard from './portal/Dashboard';

function AppContent() {
  const location = useLocation();
  const isPortal = location.pathname.startsWith('/portal');

  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('uk_user');
    return stored ? JSON.parse(stored) : null;
  });

  const handleLogin = (data) => {
    setUser({ name: data.name, role: data.role });
  };

  const handleLogout = () => {
    localStorage.removeItem('uk_token');
    localStorage.removeItem('uk_user');
    setUser(null);
  };

  return (
    <>
      {!isPortal && <Navbar />}

      <Routes>
        <Route path="/"             element={<Home />} />
        <Route path="/about"        element={<About />} />
        <Route path="/process"      element={<Process />} />
        <Route path="/services"     element={<Services />} />
        <Route path="/gallery"      element={<Gallery />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact"      element={<Contact />} />

        <Route
          path="/portal"
          element={
            user
              ? <Dashboard user={user} onLogout={handleLogout} />
              : <Login onLogin={handleLogin} />
          }
        />
      </Routes>

      {!isPortal && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}